import React from 'react';
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";

interface IProps {
    title: string;
    subtitle: string;
}

const AddLanguageWizardStepTitle: React.FC<IProps> = ({ title, subtitle }) => {
    return (
        <div>
            <div><FontBody1 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>{title}</FontBody1></div>
            <div><FontBody2 color={FONT_COLOR.PRIMARY2}>{subtitle}</FontBody2></div>
        </div>
    );
}

export default AddLanguageWizardStepTitle;